import React, { useCallback, useContext, useEffect, useState } from "react"
import { IonBadge, IonButton, IonContent, IonHeader, IonItem, IonLabel, IonList, IonMenuButton, IonPage, IonSearchbar, IonSelect, IonSelectOption, IonTitle, IonToolbar } from "@ionic/react"
import { AppContext } from "context/app.context";
import { searchPatientForms } from "misc/phqHTTP";
import { PatientFormStatusEnum } from "models/patient-phq/patient-form-status.enum";
import { PatientPHQSearchResponse } from "models/patient-phq/patient-phq.model";
import Footer from "layout/footer";
import dayjs from 'dayjs';
import startCase from 'lodash-es/startCase'
import PatientFormCard from "./PatientFormCard";

const PatientForms = () => {

    const { setIsLoading, domain } = useContext(AppContext);
    const [forms, setForms] = useState<PatientPHQSearchResponse[]>([]);
    const [formCount, setFormCount] = useState<number>(0);
    const [status, setStatus] = useState<keyof typeof PatientFormStatusEnum>("Submitted");
    const [searchedText, setSearchedText] = useState('');

    const weekAgo = dayjs().subtract(7, 'days').format('YYYY-MM-DD');
    const today = dayjs().format('YYYY-MM-DD');
    const [from, setFrom] = useState(weekAgo);
    const [to, setTo] = useState(today);

    const onSearch = useCallback((params: object) => {
        setIsLoading(true)
        searchPatientForms(params)
        .then(res => {
            setForms(res.data.result.Items);
            setFormCount(res.data.result.TotalCount);
        })
        .finally(() => {
            setIsLoading(false);
        })
    }, [setIsLoading, setForms, setFormCount])

    useEffect(() => {
        onSearch({from, to, status})
    }, [onSearch, to, from, status])

    return (
        <IonPage>
        <IonHeader>
            <IonToolbar color='primary'>
                <IonTitle className="ion-text-center">iPro Health - {domain?.Name}</IonTitle>
                <IonButton fill="clear" slot="start">
                    <IonMenuButton menu="adminMenu" color="light"></IonMenuButton>
                </IonButton>
            </IonToolbar>
            <IonToolbar className="pt-2">
                <IonTitle size="large">Patient Forms <IonBadge>{forms.length}/{formCount}</IonBadge></IonTitle>
                <IonItem className="ion-no-padding" slot="end" lines="none">
                    <IonLabel>From</IonLabel>
                    <input type="date" value={from} onChange={e => setFrom(e.target.value)} />
                </IonItem>
                <IonItem className="ion-no-padding" slot="end" lines="none">
                    <IonLabel>to</IonLabel>
                    <input type="date" defaultValue={to} onChange={e => setTo(e.target.value)} />
                </IonItem>
                <IonItem className="ion-no-padding" slot="end" lines="none">
                    <IonSelect slot="end" interface="popover" value={status} onIonChange={e => setStatus(e.detail.value)}>
                        <IonSelectOption value={null}>All</IonSelectOption>
                        {
                            Object.keys(PatientFormStatusEnum)
                            .filter((k:any) => isNaN(k) && k !== PatientFormStatusEnum[PatientFormStatusEnum.Unknown])
                            .map(k => {
                                return <IonSelectOption key={k} value={k}>{startCase(k)}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            </IonToolbar>
            <IonToolbar>
                <IonSearchbar debounce={300} value={searchedText} onIonChange={e => setSearchedText(e.detail.value!)}></IonSearchbar>
            </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonList>
                    {forms
                    .filter(f => (f.FirstName + f.LastName + f.Status).toLowerCase().includes(searchedText.toLowerCase()))
                    .map((f) => <PatientFormCard key={f.PatientPHQID} form={f} />)}
                </IonList>
            </IonContent>
            <Footer />
        </IonPage>
    )
}

export default PatientForms;